<template>
  <v-card class="workflow">
    <v-card-text>

      <div class="d-flex justify-start align-center mb-5">
        <div class="mr-4 workflow__filter">
          <v-select label="Status" v-model="filters.status" :items="getStatuses" multiple dense outlined hide-details @change="isFilterChanged=true" @blur="filterChanged()"></v-select>
        </div>

        <div class="mr-4 workflow__filter">
          <v-select label="Broadband Supplier" v-model="filters.broadband_supplier" :items="getBroadbrandSuppliers" multiple dense outlined hide-details @change="isFilterChanged=true" @blur="filterChanged()"></v-select>
        </div>

        <div class="mr-4 workflow__filter">
          <v-select label="Order Type" v-model="filters.order_type" :items="getOrderTypes" multiple dense outlined hide-details @change="isFilterChanged=true" @blur="filterChanged()"></v-select>
        </div>

        <div class="workflow__filter">
          <v-checkbox label="Automated" @click="setAutomatedFilter" :value="filters.automated" :indeterminate="filters.automated === ''"></v-checkbox>
        </div>
      </div>

      <v-data-table :headers="headers" :items="getTelcoProducts" :loading="getFetchTelcoProductsLoading" :options.sync="options" :page.sync="getTelcoWorkflowConfig.page" :server-items-length="getTelcoWorkflowConfig.pagination_count" :footer-props="{itemsPerPageOptions}" class="body--text">

        <template v-slot:header.broadband_supplier="{ header }">
          <span class="pr-1">{{ header.text }}</span>
          <BaseInfoTooltip top>Broadband supplier - owner of the telephone line</BaseInfoTooltip>
        </template>

        <template v-slot:item.product_id="{ item }">
          <a :href="`/products/${item.product_id}`" target="_blank">{{ item.product_id }}</a>
        </template>

        <template v-slot:item.automated="{ item }">
          <v-icon>{{ item.automated ? mdiCheck : '' }}</v-icon>
        </template>

        <template v-slot:item.status_entry="{ item }">
          {{ item.status_entry | daysInStatus }}
        </template>

        <template v-slot:item.quick_note="{ item }">
          <div class="d-flex justify-start align-start">
            <v-icon small @click="openProvisioningInfoDialog(item)" class="mr-1">edit</v-icon>
            <div>{{ item.quick_note }}</div>
          </div>
        </template>

        <template  v-slot:item.action="{ item }">
          <v-btn :href="queueUrl(item.product_id)" target="_blank" color="secondary" x-small>
            <v-icon small>{{ mdiFormatListText }}</v-icon>
          </v-btn>
        </template>

      </v-data-table>

      <ProvisioningInfoDialog :value="provisioningInfoOpen" :product="product" @close="closeProvisioningInfoDialog" />

    </v-card-text>
  </v-card>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from 'vuex';
  import { mdiFormatListText, mdiCheck } from '@mdi/js';
  import moment from 'moment';

  import ProvisioningInfoDialog from './ProvisioningInfoDialog.vue';

  export default {
    components: { ProvisioningInfoDialog },

    filters: {
      daysInStatus(val) {
        if (!val) {
          return '';
        }

        const date = moment(new Date());
        return date.diff(moment(val), 'days');       
      },
    },

    data() {
      return {
        mdiFormatListText,
        mdiCheck,

        queue_url: process.env.VUE_APP_QUEUE_URL || `https://queues-bonline-testing.appspot.com/`,

        headers: [
          { text: 'Product ID', sortable: false, value: 'product_id'},
          { text: 'Status', sortable: false, value: 'status'},
          { text: 'Business Name', sortable: false, value: 'business_name'},
          { text: 'Line Number', sortable: false, value: 'line_number'},
          { text: 'Order Type', sortable: false, value: 'order_type'},
          { text: 'Automated', sortable: false, value: 'automated'},
          { text: 'Two stage', sortable: false, value: 'two_stage'},
          { text: 'Days in Status', sortable: true, value: 'status_entry'},
          { text: 'BB Supplier', sortable: false, value: 'broadband_supplier'},
          { text: 'Appointment Date', sortable: true, value: 'product_detail__installation_appt_date'},
          { text: 'Expected Live Date', sortable: true, value: 'product_detail__expected_live_date'},
          { text: 'Provisioning Info', sortable: false, width: '200px', value: 'quick_note'},
          { text: '', sortable: false, value: 'action'},
        ],

        options: {
          itemsPerPage: 25,
          sortBy: [],
          sortDesc: [],
        },
        itemsPerPageOptions: [5,10,15,25,50],
        filters: {
          status: [],
          broadband_supplier: [],
          order_type: [],
          automated: "",
        },
        isFilterChanged: false,
        provisioningInfoOpen: false,
        product: {},
      }
    },

    computed: {
      ...mapGetters('telcoWorkflow', ['getTelcoProducts', 'getFetchTelcoProductsLoading', 'getTelcoWorkflowConfig', 'getStatuses', 'getBroadbrandSuppliers', 'getOrderTypes']),
    },

    watch: {
      options: {
        immediate: false,
        handler() {
          this.updateTelcoWorkflowPagination(this.options);
        },
        deep: true
      },
    },

    beforeDestroy() {
      this.RESET_TELCO_WORKFLOW_STORE();
    },

    methods: {
      ...mapMutations('telcoWorkflow', ['RESET_TELCO_WORKFLOW_STORE']),
      ...mapActions('telcoWorkflow', ['updateTelcoWorkflowPagination', 'updateTelcoWorkflowFilters']),

      setAutomatedFilter() {
        if(this.filters.automated === "") this.filters.automated = true;
        else if(this.filters.automated === true) this.filters.automated = false;
        else if(this.filters.automated === false) this.filters.automated = "";

        this.updateTelcoWorkflowFilters(this.filters);
      },

      filterChanged() {
        if(this.isFilterChanged) {
          this.updateTelcoWorkflowFilters(this.filters);
          this.isFilterChanged = false;
        }
      },

      queueUrl(product_id){
        return `${this.queue_url}telco-provisioning/actions/?product_id=${product_id}`;
      },

      openProvisioningInfoDialog(product) {
        this.provisioningInfoOpen = true;
        this.product = product;
      },

      closeProvisioningInfoDialog() {
        this.provisioningInfoOpen = false;
        this.product = {};
      }
    }
  }
</script>

<style lang="scss" scoped>
  .workflow__filter {
    max-width: 220px;
  }
</style>